import './styles.css';
import React, { Component } from 'react';
import Card from '../../../CardNew';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import { LIVEEVENTSCHANNELS } from '../../constants';
import RibbonsUtil from "../../../../utils/RibbonsUtil";
import Utils from '../../../../utils/Utils';

class RibbonLiveEventsChannels extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.ignoreSeenLast = props.ignoreSeenLast;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.hideInnerTitle = props.hideInnerTitle;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.title = props.title;
        this.unFocusHandler = props.unFocusHandler;
        this.onClickHandler = props.onClickHandler ? props.onClickHandler : null;
        this.typeRender = props.typeRender ? props.typeRender : null;
        this.onFocus = this.onFocus.bind(this);
        this.ribbonIndex = props.index;
        this.api = props.api;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.ribbonName = props.ribbonName;
        this.state = {
            newItems: this.visibleItems
        };
    }

    onFocus(event) {
        if (typeof this.focusHandler === 'function') {
            this.focusHandler(event);
        }
    }

    clickHandler(data) {
        this.onClickHandler && this.onClickHandler(data);
    }

    getEventId(event) {
        return event.event_alf_id || event.event_id
    }

    componentDidMount() {
        const secondsCarruselUpdate = Utils.getCarouselUpdate() * 1000; 

        this.intervalId = setInterval(() => {
             this.updateData();
        }, secondsCarruselUpdate);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    async updateData(){
        const newData = new RibbonsUtil();
        let newItems = await newData.getBygenreUpdate(this.props.api);
        newItems = GeneralRibbonUtils.getVisibleItems(newItems, 4, 0);

        if(JSON.stringify(newItems) !== JSON.stringify(this.visibleItems)){
            this.setState({
                newItems: newItems
            });
        }
    }

    render() {
        this.visibleItems = this.state.newItems;
        return (
            <div className="ribbon-items ribbon-last-viewed-channels">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item || node;
                    const key = Math.random() * 10;
                    const dataMetricsRibbon = {
                        node_item,
                        node_location: location.pathname,
                        ribbon_title: this.props.carruselTitle || this.ribbonId,
                    };
                    const [
                        {item: firstItem} = {},
                        {item: secondItem} = {}
                    ] = this.visibleItems;

                    return (
                        <Card
                            cover={node_item.cover}
                            unFocusHandler={this.unFocusHandler}
                            focusHandler={this.focusHandler}
                            id={ this.isModalRecordSerie ? this.getEventId(node_item) : index + 1}
                            ribbonId= {this.ribbonId}
                            key={key}
                            ribbonIndex={this.ribbonIndex}
                            ignoreSeenLast={this.ignoreSeenLast}
                            data={node_item}
                            group_id={node_item.group_id}
                            typeRender={this.typeRender}
                            onClick={(e) => {
                                this.dataUpdateMetrics(dataMetricsRibbon);
                                e.preventDefault();
                                e.stopPropagation();
                                this.clickHandler(node_item);
                            }}
                            hideTitles={this.props.hideTitles}
                            isRecentActivity={this.props.isRecentActivity}
                            label={node_item.label}
                            type={LIVEEVENTSCHANNELS}
                            title={node_item.title}
                            dataMetric={{
                                carruselTitle: this.carruselTitle,
                                cardPosition: GeneralRibbonUtils.getPosition(
                                    this.items,
                                    node_item.title
                                ),
                            }}
                            focusable={true}
                            focusRight={this.isModalRecordSerie && secondItem
                                ? `#link-${this.getEventId(secondItem)}`
                                : `#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusLeft={this.isModalRecordSerie && firstItem
                                ? `#link-${this.getEventId(firstItem)}`
                                : `#${this.ribbonId} ${this.focusSettings.selector}`}
                            setMetricsEvent={this.setMetricsEvent}
                            sibling={node_item.sibling}
                            hideInnerTitle={this.hideInnerTitle}
                            keyDownHandler={this.keyDownHandler}
                            is_music={false}
                            api={this.api}
                            ribbonName={this.ribbonName}
                            ribbonLength= {this.visibleItems.length}
                        />
                    );
                })}
            </div>
        );
    }
}

export default RibbonLiveEventsChannels;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonLiveEventsChannels/index.jsx